import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/event/accommodation';
const paymentUrl = base_url+'api/event/paymentReceipt';
const conferenceEventUrl = base_url + 'api/admin/conferenceEvent'; // ✅ Replaced accommodationSetup
const occupancyTypeUrl = base_url+'api/admin/prOccupancyType';
const receiptIdUrl = base_url+'api/event/receiptIdGeneration';
const programManagerUrl = base_url+'api/event/programManager';

export const getData = async (params) => {
  const whereParam = params;
  const response = await api.post(path, whereParam);
  return response.data.data;
};

export const getReceiptId = async (params) => {
  try {
    const response = await api.post(receiptIdUrl, params);  // Pass params directly
    return response.data.data;
  } catch (error) {
    console.error("Error fetching receipt ID:", error);
    throw error;
  }
};

export const getprogramManager = async (params) => {
    const whereParam = params;
    const response = await api.post(programManagerUrl, whereParam);
    return response.data.data;
};


export const getDataById = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { id: data.id },
  });
  return response.data;
};

export const getConferenceEvent = async (params) => {
  const whereParam = params;
  const response = await api.post(conferenceEventUrl, whereParam);
  return response.data.data;
};

export const getoccupancyType = async () => {
  const response = await api.get(occupancyTypeUrl);
  return response.data.data;
};

export const getpayment = async (params) => {
  try {
    const response = await api.post(paymentUrl, params);  // Pass params directly
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
